import React from "react";

const COLORS = ["#94a3b8", "#64748b", "#475569", "#c95a1a", "#d97706", "#2563eb", "#15803d"];

/** Horizontal funnel: one bar per stage, width = % of the first stage. */
export const FunnelBars = ({ stages = [], compact = false }) => {
  const base = stages[0]?.count || 0;
  return (
    <div data-testid="funnel-bars" style={{display:"grid",gap:compact?6:9}}>
      {stages.map((s, i) => {
        const w = base ? Math.max((s.count / base) * 100, s.count ? 3 : 0) : 0;
        return (
          <div key={s.key} data-testid={`funnel-stage-${s.key}`}
            style={{display:"grid",gridTemplateColumns:compact?"118px 1fr 92px":"150px 1fr 120px",
                    alignItems:"center",gap:10}}>
            <div className="text-small" style={{fontWeight:600,whiteSpace:"nowrap",
                 overflow:"hidden",textOverflow:"ellipsis"}}>{s.label}</div>
            <div style={{background:"#f1f5f9",borderRadius:99,height:compact?14:18,position:"relative"}}>
              <div style={{width:`${w}%`,background:COLORS[i]||"#c95a1a",height:"100%",
                   borderRadius:99,transition:"width .5s ease"}}/>
            </div>
            <div className="text-small" style={{textAlign:"right",whiteSpace:"nowrap"}}>
              <strong>{s.count}</strong>
              {s.from_prev != null && (
                <span className="text-muted"> · {s.from_prev}%</span>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default FunnelBars;
